import { multiSearchContract, searchContract } from '@exonet/jsonapi-fetcher/lib/search';
import { SEARCH_TYPES } from '../config/searchTypes';
import { DEFAULT_TAB_KEY } from '../config/constants';

const PREVIEW_SIZE = 3;
const DEFAULT_TAB_SIZE = 25;

const indexKeyByTabKey = Object.entries(SEARCH_TYPES).reduce(
  (result, [indexKey, type]) => ({
    ...result,
    [type.tabKey]: indexKey,
  }),
  {},
);

const build = (indexKey, value, customerId) =>
  searchContract(indexKey).fields(SEARCH_TYPES[indexKey].fields).customer(customerId).value(value);

const get = (tabKey, value, customerId, size = DEFAULT_TAB_SIZE) =>
  build(indexKeyByTabKey[tabKey], value, customerId).page(1, size);

const getAll = (value, customerId, indexKeys) =>
  indexKeys.reduce(
    (multi, indexKey) => multi.addQuery(build(indexKey, value, customerId), { size: PREVIEW_SIZE }),
    multiSearchContract(),
  );

export const getByTabKey = (tabKey, value, customerId, indexKeys) =>
  tabKey === DEFAULT_TAB_KEY
    ? getAll(value, customerId, indexKeys)
    : get(tabKey, value, customerId);
